import React from 'react'

function GroupTitle({title}) {
  return (
    <div>
        <h2 className='book-slide-title'>{title}</h2>
    </div>
    
  )
}

export default GroupTitle